import React from 'react'
// import useCountDown from './useCountDown';


const Timer = () => {
  
  return (
    <>
   {/* {sec} */}

    </>
  )
}

export default Timer